import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import get from "lodash/get";
import "./scss/FormInputRadioGroup.scss";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { Modal } from "react-bootstrap";

interface IFormInputRadioGroupProps {
    labels: string[];
    name: string;
    values?: (number | string)[];
    disabled?: boolean;
    col?: number;
    title?: string;
    modal?: (string | null)[];
    required?: string | null;
}

const FormInputRadioGroup: React.FC<IFormInputRadioGroupProps> = ({
    labels,
    name,
    values = [],
    disabled = false,
    col = 12,
    title = "",
    required = null,
    modal = []
}) => {
    const {
        register,
        formState: { errors },
    } = useFormContext();
    const [showModalIndex, setShowModalIndex] = useState<number | null>(null);
    const errorMessage = get(errors, name)?.message as string | undefined;

    return (
        <fieldset className="row" style={{ border: 'none', padding: 0, margin: 0 }}>
            {title && (
                <legend className="input-block__label m-0 mb-1 col-12">
                    {title}
                </legend>
            )}

            {errorMessage && (
                <p data-input-name={name} className="error m-0 mb-1">
                    {errorMessage}
                </p>
            )}

            {labels.map((label, index) => {
                const hasModal = !!modal[index];
                const optionValue = Number.isInteger(values[index]) ? values[index] : index;

                return (
                    <div key={index} className={`col-12 col-md-${col}`}>
                        <div className="d-flex align-items-center justify-content-between position-relative w-100 radio-group-wrapper">

                            <input
                                type="radio"
                                id={`${name}_${index}`}
                                value={optionValue}
                                {...register(name, {
                                    required: required ? { value: true, message: required } : false,
                                })}
                                disabled={disabled}
                                className="radio-group-input"
                            />

                            <div className="flex-grow-1 mx-1 radio-group-separator"></div>

                            <div className="d-flex align-items-center radio-group-label-container">
                                {hasModal && (
                                    <TooltipComponent content="Más Información">
                                        <div
                                            onClick={() => setShowModalIndex(index)}
                                            className="information-icon-orange p-0 mr-2"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </TooltipComponent>
                                )}

                                <label
                                    htmlFor={`${name}_${index}`}
                                    className="m-0 radio-group-label"
                                    style={{ cursor: disabled ? "not-allowed" : "pointer" }}
                                >
                                    {label}
                                </label>
                            </div>

                        </div>
                    </div>
                );
            })}

            {/* Modal final */}
            <Modal size="lg" show={showModalIndex !== null} onHide={() => setShowModalIndex(null)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {labels[showModalIndex ?? 0]}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modal[showModalIndex ?? 0]}
                </Modal.Body>
            </Modal>
        </fieldset>
    );
};

export default FormInputRadioGroup;
